import React from 'react'
import Service from '../components/services/Service'
import image4 from '../images/image4.jpeg'
import birthdaysprofile from '../images/birthdaysprofile.jpeg'
import corporateprofile from '../images/corporateprofile.jpeg'
import weddingsprofile from '../images/wedding.jpg'
import othereventsprofile from '../images/othereventsprofile.jpeg'
import graduationsprofile from '../images/graduationsprofile.jpeg'
import babyshowerprofile from '../images/babyshowerprofile.jpeg'


function Services() {
  return (
    <div>

      <div className="hero-container">
        <div>
          <img
            src={image4}
            alt="Event"
            className="services-hero-image"
          />
        </div>

        <div className="overlay-box">
          <div className="overlay-content">
            <h1 className="section-title">Our Services</h1>
            <p>Decor Delights & Events offers premium event decoration services, specialising in weddings, corporate events, social celebrations, and special occasions. Our team provides complete end-to-end decoration solutions, handling every detail from concept design and venue styling to floral arrangements, themed décor, and final setup. We create elegant, unforgettable event spaces tailored to your vision, style, and celebration. Every detail is thoughtfully designed to bring your dream event to life.</p>
          </div>
        </div>
      </div>

      <div className='services-list-container'>
        <div className="services-list">
          <Service header="Weddings" source={weddingsprofile} description="We design stunning wedding décor that brings your love story to life. From elegant ceremony spaces and romantic reception styling to floral bouquets and lighting accents, every detail is crafted to reflect your vision and create a memorable celebration." />
          <Service header="Corporate events and conferences" source={corporateprofile} description="Our corporate event décor delivers polished, professional environments for conferences, meetings, awards, and product launches. We combine branded styling, modern staging, and thoughtful details to create cohesive spaces that impress clients, teams, and guests." />
          <Service header="Birthday parties" source={birthdaysprofile} description="We create fun and festive birthday décor for every age and theme. From colourful table settings and balloons to signature centrepieces and backdrop displays, our decorations make each celebration feel joyous, personalised, and unforgettable." />
          <Service header="Graduations" source={graduationsprofile} description="Our graduation décor honours academic achievements with elegant styling and celebratory details. We design memorable stage setups, photo areas, and reception décor to mark the milestone and create a polished, festive atmosphere for graduates and guests." />
          <Service header="Baby showers" source={babyshowerprofile} description="We craft charming baby shower décor with soft palettes, whimsical details, and thoughtful touches. From sweet table arrangements and themed accents to inviting lounge areas, our decorations make the celebration feel warm, joyful, and beautifully styled." />
          <Service header="Other events" source={othereventsprofile} description="We also decorate a wide range of special occasions, including anniversaries, engagement parties, community gatherings, and milestone celebrations. Whatever the event, we provide creative décor solutions that transform your venue into a standout experience." />
        </div>
      </div>
    </div>
  )
}

export default Services 